export default "__VITE_ASSET__DEAnLitr__"